import styled from 'styled-components';
const TagLink = styled.span`
  display: inline-block;
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 14px;
  font-weight: bold;
  color: ${({
  theme
}) => theme.base.black};
  text-decoration: none;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 0;
    left: 0;
    bottom: 0;
    border-bottom: 2px solid ${({
  theme
}) => theme.base.black};
  }

  &:hover {
    color: ${({
  theme
}) => theme.primary.light};

    &::after {
      border-bottom: 2px solid ${({
  theme
}) => theme.primary.light};
    }
  }

  &:active {
    color: ${({
  theme
}) => theme.primary.dark};

    &::after {
      border-bottom: 2px solid ${({
  theme
}) => theme.primary.dark};
    }
  }
`;
export default TagLink;